import { DetailedHTMLProps, HTMLAttributes } from "react";

import { StyledContainer } from "@/components/containers/RoundedTopLeftContainer/styles";

export const RoundedTopLeftContainer = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
) => <StyledContainer {...props} />;
